class FormSubmitValidation {
  constructor($stageForm) {
    this.$stageForm = $stageForm
    this.$submitButton = this.$stageForm.querySelector('.js-submit-loader, [type="submit"]'); // This has a class "js-submit-loader" if used with .js-submit-text
    this.$submitText = this.$stageForm.querySelector('.js-submit-text'); // This might not exists
    this.$errorSummary = this.$stageForm.querySelector('.error-summary');
    this.$fields = Array.from(this.$stageForm.elements);

    this.$stageForm.doSubmit = this.doSubmit.bind(this); // expose doSubmit to be used in recaptha's callback
    this.$submitButton.addEventListener('click', this.handleSubmit.bind(this), {capture: true}); // Capture to prevent function calling before hcapcha events are triggered
    this.$stageForm.addEventListener('submit', this.handleSubmit.bind(this), {capture: true});

    // Initially, if form has any Stage errors after POST > show them all and focus the first one
    let isFirstError = true;
    for(const $field of this.$fields){
      $field.$wrapper = $field.closest('.form-group');
      $field.$requiredError = $field.$wrapper?.querySelector(`#${$field.id}-required-error`);
      $field.$invalidError = $field.$wrapper?.querySelector(`#${$field.id}-invalid-error`);
      if($field.tagName === 'SELECT'){
        $field.addEventListener('change', this.handleFieldInput.bind(this));
      } else {
        $field.addEventListener('input', this.handleFieldInput.bind(this));
      }
      $field.addEventListener('blur', this.handleFieldBlur.bind(this));
      if($field.classList.contains('stage-error')){
        this.showFieldError($field, isFirstError ? false : true);
        isFirstError = false;
      }
    }
  }

  handleSubmit(evt){
    evt.preventDefault();

    // Validate each field
    let $erroredFields = [];
    for(const $field of this.$fields){
      if(!$field.checkValidity()){
        // Field has an error > show the error, focus and exit before validating next
        // Note: not displaying all the errors at once, hard for screen reader users
        this.showFieldError($field, false);
        $erroredFields.push($field);
      }
    }

    if($erroredFields.length){
      // Form has error > show first error (again) and focus the field
      this.showFieldError($erroredFields[0]);
      // Apply errors for screen reader
      this.showErrorSummary($erroredFields);
      return;
    } else {
      // No errors > Clear errors for screen reader
      this.clearErrorSummary();
    }

    // Form is valid > Trigger recaptcha (if exists) or submit the form
    const recaptchaWidgetId = this.$stageForm.querySelector('[data-hcaptcha-widget-id]')?.getAttribute('data-hcaptcha-widget-id');
    if(recaptchaWidgetId && window.grecaptcha){
      // recaptcha and recaptchaWidgetId exists > Trigger recaptcha
      // Note: grecaptcha callback shoud then call $form.doSubmit() which is this.doSubmit()
      window.grecaptcha.reset(recaptchaWidgetId);
      window.grecaptcha.execute(recaptchaWidgetId);
    } else {
      // No recaptcha, just submit
      this.$stageForm.doSubmit();
    }
  }

  doSubmit(){
    // Disable submit button, show loader (if exists) and do actual submit
    this.$submitButton.disabled = true;
    this.$submitText?.classList.remove('d-none');
    this.$stageForm.submit();
  }

  handleFieldInput(evt){
    // When typing, hide possible previous error
    // This is to make sure that uset will see if the new input is still invalid (on lbur)
    const $field = evt.target;
    this.clearFieldError($field);
  }

  handleFieldBlur(evt){
    // Validate field and show possible error
    // Note: without focusing the field to prevent focus trap and allow tabbing throug the form
    const $field = evt.target;
    if(!$field.checkValidity()){
      this.showFieldError($field, true);
    }
  }

  showFieldError($field, preventFocus){
    // Just show the error element or the native error message
    // Update aria attributes etc.

    $field.setAttribute('aria-invalid', 'true');
    $field.classList.add('stage-error');
    $field.$wrapper.classList.add('has-error');
    // Pick custom error element by error kind, or null if field does not have it
    const $error = $field.validity.valueMissing ? $field.$requiredError : !$field.validity.valid ? $field.$invalidError : null;

    if($error){
      // Field has custom error element for this kind of error > Show it
      $field.setAttribute('aria-describedby', $error.id);
      $error.setAttribute('aria-hidden', 'false');
      $error.classList.remove('d-none');
      if(!preventFocus){
        $field.focus();
      }
      return
    }

    // Field doesn't have a custom error element > Show browsers default
    if(!preventFocus){
      // Only if focusing is not prevented, because this will also focus the field
      $field.reportValidity();
    }
  }

  clearFieldError($field){
    // Just clear all errors from the field

    $field.setAttribute('aria-invalid', 'false');
    $field.classList.remove('stage-error');
    $field.$wrapper.classList.remove('has-error');
    $field.removeAttribute('aria-describedby');

    // Clear all kind of errors
    const $errors = [$field.$requiredError, $field.$invalidError].filter($error => $error);
    $errors.forEach($error => {
      $error.setAttribute('aria-hidden', 'true');
      $error.classList.add('d-none');
    })
  }

  showErrorSummary($fields){
    if(!this.$errorSummary) return;
    // $fields could be used e.g. to show count of errored fields, or list of errored field names..
    // Currently just show the error element
    this.$errorSummary.setAttribute('aria-hidden', 'false');
    this.$errorSummary.classList.remove('d-none');
  }

  clearErrorSummary(){
    if(!this.$errorSummary) return;
    this.$errorSummary.setAttribute('aria-hidden', 'true');
    this.$errorSummary.classList.add('d-none');
  }
}

const initializeFormSubmitValidation = () => {
  const $stageForms = document.querySelectorAll('.stage-form');
  $stageForms.forEach($stageForm => {
    new FormSubmitValidation($stageForm);
  })
}

export default initializeFormSubmitValidation
